import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(Array.isArray(r.data) ? r.data : [])); }, []);
  return (
    <div className="p-4 md:p-8">
      <div className="flex items-start justify-between mb-6">
        <div><div className="tinylabel">Compliance</div><h1 className="text-3xl font-black">Audit Trail</h1></div>
        <a data-testid="export-audit-csv" href={`${API_BASE}/exports/audit.csv`}
           className="h-11 px-4 border border-slate-300 rounded-md font-semibold hover:bg-slate-50 flex items-center">Export CSV</a>
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500"><tr><th className="text-left px-4 py-3">When</th><th className="text-left px-4 py-3">Actor</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Entity</th><th className="text-left px-4 py-3">Entity ID</th><th className="text-left px-4 py-3">IP</th><th className="text-left px-4 py-3">Detail</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-6 text-slate-400">No audit events.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`audit-row-${r.id}`}>
                <td className="px-4 py-3 text-slate-500 text-xs">{r.created_at}</td>
                <td className="px-4 py-3 font-medium">{r.actor}</td>
                <td className="px-4 py-3 uppercase text-xs font-bold tracking-widest text-green-600">{r.action}</td>
                <td className="px-4 py-3">{r.entity}</td>
                <td className="px-4 py-3 font-mono text-xs">{r.entity_id}</td>
                <td className="px-4 py-3 text-slate-500 text-xs">{r.ip || "—"}</td>
                <td className="px-4 py-3 text-slate-600 text-sm">{r.detail || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
